import {
  init_icon_button
} from "./chunk-RIVWPZ44.mjs";
import {
  __esm
} from "./chunk-ZU6LNBSF.mjs";

// src/components/icon-button/index.ts
var init_icon_button2 = __esm({
  "src/components/icon-button/index.ts"() {
    init_icon_button();
  }
});

export {
  init_icon_button2 as init_icon_button
};
